export default [
  {
    url: "/admin/dashboard",
    name: "ダッシュボード",
    icon: "HomeIcon",
    i18n: 'Dashboard',
    slug: 'admin-dashboard'
  },
  {
    url: '/admin/admin-management',
    name: '管理者',
    icon: 'UserCheckIcon',
    i18n: 'Admin',
    slug: 'admin-management'
  },
  {
    url: '/admin/user',
    name: '利用者設定',
    icon: 'UserIcon',
    i18n: 'UserManagement',
    slug: 'admin-user'
  },
  {
    url: '/admin/customer',
    name: '顧客管理',
    icon: 'UsersIcon',
    i18n: 'CustomerManagement',
    slug: 'admin-customer'
  },
  {
    url: '/admin/telephone-server',
    name: '電話管理',
    icon: 'PhoneIcon',
    i18n: 'TelephoneServer',
    slug: 'admin-telephone-server'
  },
  {
    url: '/admin/status-management',
    name: '状態管理',
    icon: 'BookmarkIcon',
    i18n: 'StatusManagement',
    slug: 'admin-status-management'
  },
  {
    url: '/admin/mail-server',
    name: 'メールサーバ',
    icon: 'MailIcon',
    i18n: 'MailServer',
    slug: 'admin-server'
  },
  {
    url: '/admin/mail-error',
    name: 'エラー一覧',
    icon: 'AlertCircleIcon',
    i18n: 'エラー一覧',
    slug: 'admin-mail-error'
  },
  {
    url: '/admin/kinds',
    name: '種別管理',
    icon: 'FileTextIcon',
    i18n: 'KindsManagement',
    slug: 'admin-kinds'
  },
  {
    url: '/admin/subscription',
    name: 'サブスクライブ',
    icon: 'InboxIcon',
    i18n: 'Subscription',
    slug: 'admin-subscription'
  },
  {
    url: '/admin/settings',
    name: '制限設定',
    icon: 'SettingsIcon',
    i18n: 'Settings',
    slug: 'admin-settings'
  },
  {
    url: "/shachi/dashboard",
    name: "利用状況",
    icon: "MonitorIcon",
    i18n: 'ShachiDashboard',
    slug: 'shachi-dashboard'
  },
  {
    url: '/shachi/mail-send-resume',
    name: '送信状況',
    icon: 'SendIcon',
    i18n: 'MailSendResume',
    slug: 'mail-send-resume'
  },
  {
    url: '/shachi/company',
    name: '企業設定',
    icon: 'ToolIcon',
    i18n: 'CompanySettings',
    slug: ''
  },
  {
    url: '/shachi/settings',
    name: '設定',
    icon: 'ClockIcon',
    i18n: 'GlobalSettings',
    slug: 'shachi-settings'
  },
]
